import { useCropImageBottomMenu } from "./useCropImageBottomMenu";
import { SettingsIcon } from "client/components/common/Icons/SettingsIcon";
import { BottomModal } from "components/common/BottomModal/BottomModal";
import { CloseIcon } from "components/common/Icons/CloseIcon";
import { ImageCropperCropSettings } from "../EditSettings/CropSettings/ImageCropperCropSettings";
import { SKIP_TOUCH_ID_BOTTOM_MODAL } from "components/common/BottomModal/useBottomModal";

import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { ImageCropperCropBottomSection } from "components/modules/Editors/Crop/BottomMenu/ImageCropperCropBottomSection";

export const ImageCropperBottomMenu = () => {
    const { isOpen, open, close } = useCropImageBottomMenu();

    return (
        <div className="py-4 px-4 dark:bg-darkSurface-100 dark:border-t dark:border-t-darkSurface-600">
            <div
                className="bg-irBlue-200 dark:bg-darkPrimary-100 rounded-xl flex items-center justify-center py-2 gap-4"
                onClick={open}
            >
                <SettingsIcon />
                <div className="text-white font-semibold text-xl capitalize">
                    {capitalize(`${translateFunc("crop")} ${translateFunc("settings")}`)}
                </div>
            </div>

            <BottomModal
                isOpen={isOpen}
                onClose={close}
                interactiveBackground={true}
                titleBar={
                    <div className="w-full flex items-center justify-between px-4 pt-2 text-black dark:text-white">
                        <div className="capitalize text-xl whitespace-nowrap font-semibold">Crop Settings</div>
                        <div
                            className="bg-irGray-300 dark:bg-darkSurface-200 h-6 w-6 rounded-full flex items-center justify-center"
                            onClick={close}
                            id={SKIP_TOUCH_ID_BOTTOM_MODAL}
                        >
                            <CloseIcon />
                        </div>
                    </div>
                }
                bottomSection={<ImageCropperCropBottomSection />}
            >
                <div className="px-4 py-8 text-black">
                    <ImageCropperCropSettings />
                </div>
            </BottomModal>
        </div>
    );
};
